// French UI strings (machine-translated from EN, reviewed keys)
export const FR_UI = {
 "dur_0": "Illimité",
 "dur_30": "30 jours (essai)",
 "dur_365": "1 an / 365 jours",
 "dur_730": "2 ans / 730 jours",
 "pack_BASIS": "LICENCE ANNUELLE BASIC (9 €/an)",
 "colUntil": "Valable jusqu’au",
 "licActiveUntil": "Active jusqu’au : {date} ({days} jours restants)",
 "licYearExpired": "Votre licence annuelle ({price} €/an) a expiré le {date}. Veuillez saisir un nouveau code d’activation annuel pour continuer (toutes les données enregistrées sont conservées).",
 "demoActive": "Mode essai 14 jours (démo) : {days} jour(s) restant(s) – toutes les fonctions sont débloquées.",
 "demoOver": "La période d’essai de 14 jours est terminée. Veuillez demander une licence annuelle pour continuer (toutes les données enregistrées sont conservées).",
 "needLicense": "Aucune licence annuelle valide – les exports et les nouvelles saisies sont verrouillés. Veuillez saisir un code d’activation annuel.",
 "playBasis": "Licence annuelle Basic (9,00 € / an – via Google Play)",
 "playInv": "Module complémentaire inventaire photo (+9,00 € / an – via Google Play)",
 "playAll": "GISS FieldRapport Pro – Édition complète avec compteur de matériel photo, calculateur de fouille, carte plein écran et tous les exports CAD/GIS (18,00 € / an – via Google Play)",
 "playRestore": "Restaurer les achats",
 "playOnly": "Les achats sont disponibles uniquement dans la version Google Play de l’application.",
 "playErr": "L’achat Google Play n’a pas pu être confirmé.",
 "playOk": "Achat réussi – licence activée !",
 "playRestored": "Achats restaurés – licence active.",
 "playNothing": "Aucun achat actif trouvé.",
 "entActive": "Licence entreprise (version complète)",
 "entExpired": "Votre licence entreprise a expiré le {date}. Veuillez contacter votre administrateur (toutes les données enregistrées sont conservées).",
 "entSeatsFull": "Erreur de licence : tous les emplacements appareil de cette licence entreprise sont déjà utilisés.",
 "entKeyLabel": "Saisir la clé de licence entreprise / flotte",
 "entKeyPlaceholder": "p. ex. GISS-ENT-… ou code lié à l’appareil",
 "entLinkOk": "Licence entreprise activée via lien – version complète débloquée !",
 "playAdmTitle": "Google Play – vérification des achats & clé d’envoi",
 "playAdmKey": "Choisir la clé du compte de service (.json / .txt)",
 "playAdmKeyOk": "Clé vérifiée et enregistrée – la vérification des achats est ACTIVE",
 "playAdmMissing": "Avertissement : abonnement/forfait de base manquant ou inactif : {list}",
 "playAdmMode": "Mode",
 "playAdmLive": "LIVE (achats réels)",
 "playAdmTest": "TEST",
 "playAdmToTest": "Passer en test",
 "playAdmToLive": "Passer en direct",
 "playAdmNone": "Aucune clé enregistrée",
 "playAdmZip": "Choisir la clé d’envoi (GISS-upload-key.zip)",
 "playAdmPwd": "Mot de passe du keystore",
 "playAdmZipOk": "Clé d’envoi enregistrée",
 "playAdmZipSaved": "Clé d’envoi stockée",
 "playErr_key_format": "Le fichier n’est pas une clé de compte de service valide",
 "playErr_key_auth": "Google rejette la clé (supprimée ou endommagée ?)",
 "playErr_key_access": "Clé valide mais sans autorisation dans la Play Console (peut prendre jusqu’à 24 h)",
 "playErr_zip_format": "Le fichier n’est pas un ZIP valide",
 "playErr_zip_no_keystore": "Aucun fichier .keystore/.jks trouvé dans le ZIP",
 "entTitle": "Licence entreprise / lien unique",
 "entCompany": "Nom de l’entreprise",
 "entSeats": "Nombre d’appareils",
 "entBase": "Base du lien",
 "entBtn": "Créer le lien d’activation directe",
 "entDevices": "appareils",
 "entCopyLink": "Copier le lien",
 "entBad": "Veuillez saisir le nom de l’entreprise et le nombre d’appareils.",
 "entConfirmRelease": "Libérer cet appareil ? L’emplacement redevient disponible, l’appareil perdra la licence lors de son prochain contrôle en ligne.",
 "entRelease": "Libérer l’appareil",
 "entMail": "Madame, Monsieur,\n\nveuillez trouver ci-joint votre licence entreprise pour {app} ({company}, {seats} appareils, valable jusqu’au {date}).\n\nOuvrez ce lien d’activation sur chaque appareil :\n{link}\n\nVous pouvez aussi saisir la clé sous Paramètres → Modules & licences GISS :\n{code}\n\nCordialement\nGISS - Software Solutions",
 "genSingle": "Appareil unique : code annuel lié à l’appareil",
 "entQrPng": "Code QR en PNG",
 "entQrPdf": "Fiche d’instructions (PDF)",
 "entSheetTitle": "Activation de votre licence entreprise",
 "entSheetScan": "Scannez avec l’appareil photo du téléphone – l’application s’ouvre avec la licence complète.",
 "entSheetSteps": "Fonctionnement :\n1. Scannez le code QR avec l’appareil photo de l’appareil et ouvrez le lien.\n2. L’application s’ouvre et confirme : licence entreprise activée.\n3. Vous pouvez aussi saisir la clé sous Paramètres > Modules & licences GISS :\n   {code}\nRemarque : chaque appareil utilise un emplacement de licence. Une connexion Internet est nécessaire une fois pour l’activation.",
 "licOpen": "Ouvrir les licences",
 "entOverview": "Aperçu entreprise",
 "entExtend": "Prolonger de +1 an",
 "entExtendConfirm": "Prolonger d’1 an la licence de « {company} » ? Tous les appareils recevront automatiquement la prolongation lors de leur prochaine connexion.",
 "entExtended": "Prolongée jusqu’au {date} – les appareils se mettent à jour automatiquement.",
 "entDaysLeft": "{days} jours restants",
 "entSt_ok": "active",
 "entSt_soon": "expire bientôt",
 "entSt_expired": "expiré",
 "entSt_revoked": "révoqué",
 "pack_ENT": "ENTERPRISE (version complète)",
 "genSendMsg": "Votre code d’activation annuel GISS FieldRapport Pro ({pkg}) pour l’appareil {device} :\n{code}\nValable jusqu’au {date}. Saisissez-le sous Paramètres → Modules & licences GISS.",
 "genDuration": "Durée",
 "genNote": "Client / note",
 "genList": "Codes client générés",
 "colCode": "Code",
 "colDevice": "Appareil",
 "colCreated": "Créé",
 "colActivated": "Activé",
 "colStatus": "Statut",
 "stActive": "actif",
 "stUnused": "non activé",
 "stExpired": "expiré",
 "stRevoked": "révoqué",
 "revoke": "Révoquer",
 "confirmRevoke": "Révoquer ce code ? Il ne pourra plus être activé.",
 "licExpired": "Erreur de licence : ce code d’activation a expiré.",
 "licRevoked": "Erreur de licence : ce code d’activation a été révoqué.",
 "licOffline": "Aucune connexion au serveur de licences GISS. Veuillez activer en ligne.",
 "validUntil": "valable jusqu’au",
 "unlimited": "illimité",
 "remindSoon": "Votre licence \"{mods}\" expire dans {days} jour(s) (le {date}).",
 "remindToday": "Votre licence \"{mods}\" expire aujourd’hui.",
 "remindExpired": "Votre licence \"{mods}\" a expiré.",
 "renewHint": "Support (veuillez indiquer l’ID de votre appareil) :",
 "blockedTitle": "Licence désactivée",
 "blockedText": "L’activation suivante a été désactivée par le serveur de licences ({reason}) : {mods}. Toutes vos données sont conservées.",
 "reason_revoked": "révoqué",
 "reason_expired": "expiré",
 "reason_invalid": "invalide",
 "reason_device": "autre appareil",
 "dismiss": "Masquer",
 "understood": "Compris",
 "contactTitle": "Contact du support (affiché lorsqu’une licence est bloquée)",
 "contactName": "Nom / société",
 "contactPhone": "Téléphone",
 "contactEmail": "E-mail",
 "contactWeb": "Site web",
 "contactSave": "Enregistrer le contact",
 "contactSaved": "Contact enregistré",
 "ownerExpired": "Session propriétaire expirée – veuillez saisir à nouveau la clé maître.",
 "refresh": "Actualiser",
 "priceTitle": "Bordereau des prix du matériel (prix unitaires)",
 "priceAdd": "Ajouter une pièce",
 "priceName": "Type de pièce",
 "priceUnit": "Prix unitaire €",
 "priceEmpty": "Aucun prix pour le moment. Les prix peuvent aussi être saisis directement pendant le comptage.",
 "invPrice": "Prix unitaire €",
 "invAmount": "Montant",
 "invSum": "Total matériel",
 "colUnitPrice": "Prix unitaire (€)",
 "colAmount": "Montant (€)",
 "pdfMaterial": "Facturation du matériel",
 "pdfMatOverview": "Aperçu du matériel (tous les comptages)",
 "btnHistory": "Historique des comptages",
 "histTitle": "Historique des comptages – tous les comptages de matériel du projet",
 "histEmpty": "Aucun comptage de matériel dans ce projet pour le moment.",
 "histCounts": "comptages",
 "histPieces": "pièces",
 "histXlsx": "Exporter vers Excel",
 "histTotals": "Totaux par type de pièce",
 "histDate": "Date",
 "histSheetDetail": "Comptages individuels",
 "histSheetSum": "Totaux",
 "invNextPhoto": "Photo suivante",
 "invNextGallery": "Depuis la galerie",
 "invSavedNext": "Comptage appliqué – comptage de la photo suivante.",
 "deviceId": "Votre ID appareil",
 "copy": "Copier",
 "copied": "Copié",
 "licDevice": "Le code appartient à un autre appareil ou n'est pas valide.",
 "licDeviceHint": "ID de votre appareil – requis pour les licences entreprise et flotte.",
 "adminOk": "Mode propriétaire actif : tous les modules sont déverrouillés",
 "genTitle": "GISS Enterprise & Générateur de licences",
 "genDevice": "ID de l'appareil du client (p. ex. GISS-DEV-482910)",
 "genModule": "Module",
 "pack_PRO": "Version complète PRO",
 "pack_INV": "MODULE INVENTAIRE / COMPTEUR PHOTO (+9 €/an)",
 "pack_ALL": "ÉDITION COMPLÈTE (18 €/an)",
 "genBtn": "Générer le code annuel",
 "genBadDev": "ID d'appareil invalide (format GISS-DEV-123456)",
 "genResult": "Code d'activation pour le client",
 "adminExit": "Quitter le mode propriétaire",
 "projDescTitle": "Description générale du projet / Données de commande",
 "projDescPlaceholder": "Client, numéro de commande, périmètre des travaux, interlocuteur…",
 "modeSingle": "Rapport unique",
 "modeProject": "Projet",
 "btnNewSingle": "Créer un rapport unique",
 "btnNewProjectMode": "Travailler dans un projet",
 "convertToProject": "Convertir en projet",
 "projLocBtn": "Emplacement du projet = centre de la carte",
 "projLocSet": "Emplacement du projet défini",
 "addrPlaceholder": "Rechercher une adresse ou des coordonnées (p. ex. 10 Downing St, London)",
 "addrGo": "Rechercher",
 "addrNone": "Aucun résultat trouvé.",
 "addrErr": "Échec de la recherche d'adresse.",
 "addrOffline": "La recherche d'adresse nécessite internet – hors ligne, saisir des coordonnées (p. ex. 47.979, 7.829).",
 "addrSetReport": "Déplacer le rapport ici",
 "addrSetProject": "Déplacer le centre du projet ici",
 "addrRepSet": "Position du rapport définie",
 "addrAttr": "Recherche : © OpenStreetMap / Nominatim / Photon",
 "addrLabel": "Adresse",
 "addrClearRecent": "Effacer l'historique",
 "routeBtn": "Itinéraire",
 "routeTitle": "Démarrer la navigation dans Google Maps",
 "routeDayBtn": "Planifier la tournée du jour",
 "routeDayTitle": "Tournée du jour – rapports ouverts",
 "routeLocating": "Localisation …",
 "routeFromGps": "Départ : votre position GPS",
 "routeFromMap": "Départ : centre de la carte (GPS indisponible)",
 "routeNone": "Tous les rapports sont terminés – aucun arrêt ouvert.",
 "routeOpen": "arrêts ouverts",
 "routeAir": "distance totale à vol d'oiseau",
 "routeLeg": "Étape",
 "routeOpenLeg": "Ouvrir l'étape dans Google Maps",
 "routeOpenMaps": "Ouvrir l'itinéraire dans Google Maps",
 "repDone": "Terminé",
 "shareReport": "Partager le PDF du rapport",
 "shareProject": "Partager le PDF du projet",
 "shareFooter": "Créé avec",
 "shareFallback": "Partage non pris en charge ici – PDF téléchargé, texte du message copié dans le presse-papiers.",
 "workLabel": "Sélectionner le travail",
 "singleBadge": "UNIQUE",
 "btnDxf": "Export AutoCAD (.dxf)",
 "btnGeojson": "Export SIG réseaux (.geojson)",
 "btnCsvAufmass": "Excel / Tableau de métrés (.csv)",
 "btnGpx": "Export appareils GPS (.gpx)",
 "btnZip": "Pack bureau complet (.zip)",
 "bnProject": "PROJET GLOBAL / VUE D'ENSEMBLE DU RÉSEAU",
 "bnReport": "RAPPORT DE CHANTIER / NŒUD",
 "bnPoint": "POINT DE RAPPORT",
 "bnDetail": "Photo de détail pour le rapport",
 "bnFitting": "ROBINETTERIE / NŒUD",
 "pdfToc": "Sommaire – Emplacements de chantier",
 "dictate": "Dicter",
 "dictating": "Enregistrement... (appuyer pour arrêter)",
 "kpiLen": "Longueur totale de conduite",
 "appTitle": "GISS FieldRapport Pro",
 "appSub": "Rapport de chantier · Réseau de conduites · hors ligne",
 "settings": "Paramètres",
 "logoTitle": "Logo de l’entreprise pour l’en-tête PDF",
 "logoUpload": "Téléverser le logo",
 "logoRemove": "Supprimer le logo",
 "licTitle": "Modules & licences GISS",
 "licPlaceholder": "Saisir le code d’activation",
 "licActivate": "Activer",
 "licOk": "Activé : ",
 "licBad": "Code d’activation invalide",
 "licActive": "Modules actifs",
 "licNone": "Aucun module activé (version de base)",
 "mod_pro": "Licence annuelle de base",
 "mod_inventory": "Module d’inventaire / comptage photo",
 "about": "À propos",
 "publisher": "Éditeur",
 "version": "Version",
 "close": "Fermer",
 "btnCount": "Compter le matériel par photo",
 "invLocked": "Le module de comptage du matériel n’est pas activé. Veuillez saisir un code d’activation dans les paramètres.",
 "invTitle": "GISS Inventory – Compter le matériel",
 "invAuto": "Comptage auto (IA)",
 "invLocal": "Détecteur local",
 "invRunning": "Comptage des pièces…",
 "invAiErr": "Détection IA indisponible – détecteur local par contraste utilisé",
 "invHint": "Touchez une pièce manquante (+1) ou un point existant pour le supprimer (−1).",
 "invType": "Type de pièce pour les nouveaux points",
 "invNewType": "+ Nouveau type",
 "invTotal": "Total",
 "invApply": "Ajouter au rapport",
 "invUsed": "Matériel utilisé",
 "invCaption": "Comptage du matériel (photo justificative)",
 "invDefaultType": "Pièce",
 "invPromptType": "Nom du type de pièce (p. ex. vis) :",
 "filterTitle": "Filtre d’état",
 "filterAll": "Tous",
 "showOnMap": "Afficher sur la carte",
 "locate": "Afficher",
 "btnXlsx": "Plan du réseau Excel (.xlsx)",
 "btnCsv": "Plan du réseau CSV (.csv)",
 "colNo": "N°",
 "colName": "Nom",
 "colType": "Type",
 "colDn": "DN / Matériau",
 "colLen": "Longueur (m)",
 "colFrom": "De",
 "colTo": "À",
 "colLinks": "Raccords connectés",
 "colPoints": "Points",
 "colState": "État",
 "colNote": "Remarque",
 "colLat": "Latitude",
 "colLon": "Longitude",
 "colPhotos": "Photos",
 "colVideos": "Vidéos",
 "colMemos": "Mémos vocaux",
 "colCount": "Nombre",
 "sheetPipes": "Conduites",
 "sheetFittings": "Raccords",
 "sheetSummary": "Facturation",
 "sheetMaterial": "Matériel",
 "sumPipes": "Longueur par type et DN",
 "sumFittings": "Raccords par type et état",
 "sumMaterial": "Matériel utilisé (comptage photo)",
 "btnInstall": "Installer l’application",
 "iosInstall": "Pour installer : touchez Partager puis choisissez \"Ajouter à l’écran d’accueil\".",
 "vertexDelete": "Supprimer le point de coude",
 "splitDone": "Conduite scindée au raccord",
 "vertexAdded": "Point de coude inséré",
 "netEditHint": "Touchez une conduite pour insérer un point de coude ; touchez un point de coude pour le supprimer.",
 "pdfCreated": "Créé avec GISS FieldRapport Pro | GISS - Software Solutions (www.giss.cc) - Engineered by Leakbuster",
 "fitHint": "Touchez la carte (ou « Point au réticule ») pour placer l’accessoire. En touchant directement une conduite, elle est scindée au niveau du nouvel accessoire.",
 "legend": "Légende",
 "legendPipes": "Types de conduites",
 "legendFittings": "Accessoires",
 "btnNetUnlock": "Déverrouiller le réseau (déplacer les points)",
 "btnNetConfirm": "Confirmer les nouvelles positions et verrouiller",
 "netEditBadge": "Édition du réseau – déplacer les accessoires et points de courbure",
 "netConfirmed": "Positions du réseau confirmées et verrouillées",
 "fitState": "État",
 "st_none": "Aucun état",
 "st_open": "Ouvert",
 "st_closed": "Fermé",
 "st_partial": "Partiellement ouvert",
 "st_ok": "OK",
 "st_defect": "Défectueux",
 "st_check": "À contrôler",
 "btnPhoto": "Photo",
 "btnVideo": "Enregistrer une vidéo",
 "video": "Vidéo",
 "btnMemo": "Mémo vocal et dictée",
 "btnStop": "Arrêter",
 "recording": "Enregistrement…",
 "memoTitle": "Mémos vocaux",
 "noSpeech": "La reconnaissance vocale n’est pas prise en charge par ce navigateur – seul l’audio est enregistré.",
 "micErr": "Microphone indisponible",
 "pipeFrom": "De",
 "pipeTo": "à",
 "freePoint": "point libre",
 "connected": "connecté",
 "pdfLegend": "Légende",
 "pdfMemo": "Mémo vocal",
 "photoWord": "Photo",
 "confirmDelMemo": "Supprimer le mémo vocal ?",
 "drawHint": "Touchez la carte pour ajouter des points de courbure libres ou touchez un accessoire pour y raccorder la conduite (topologiquement). « Point au réticule » ajoute un point au centre de la carte.",
 "btnAddFitting": "Placer un accessoire",
 "btnCrosshair": "Point au réticule",
 "btnDone": "Terminé",
 "fittingsTitle": "Accessoires / Points de réseau",
 "noFittings": "Aucun accessoire placé pour le moment.",
 "fitNote": "Note / DN",
 "confirmDelFit": "Supprimer cet accessoire ?",
 "fit_hydrant": "Borne hydrante",
 "fab_hydrant": "H",
 "fit_valve": "Vanne",
 "fab_valve": "V",
 "fit_manhole": "Regard",
 "fab_manhole": "MH",
 "fit_house": "Branchement",
 "fab_house": "HC",
 "fit_air": "Ventouse",
 "fab_air": "AV",
 "fit_drain": "Vidange",
 "fab_drain": "DR",
 "fit_other": "Autre",
 "fab_other": "?",
 "fit_leak": "Dommage / fuite",
 "fab_leak": "!",
 "objKind_fitting": "Accessoire / pièce",
 "objKind_pipe": "Conduite",
 "objKind_pit": "Fouille",
 "objKind_media": "Photo / vidéo",
 "objDragHint": "Glisser sur la carte = déplacer",
 "catTitle": "Gestionnaire des matériaux et accessoires",
 "catOpen": "Données de référence",
 "catSector": "Secteur d’infrastructure",
 "sec_water": "Alimentation en eau / réseau d’eau potable",
 "sec_sewer": "Assainissement (bientôt disponible)",
 "sec_power": "Électricité / gaz (bientôt disponible)",
 "sec_building": "Bâtiment / peinture (bientôt disponible)",
 "cat_valve": "Vanne / arrêt",
 "cat_hydrant": "Borne incendie & ventouse",
 "cat_house": "Branchement & compteur d'eau",
 "cat_dma": "Surveillance du réseau & secteurs (DMA)",
 "cat_pipe": "Conduite",
 "cat_repair": "Raccord / réparation",
 "cat_shaft": "Regard",
 "catCat": "Catégorie",
 "catName": "Nom",
 "catDim": "Dimension / spécification",
 "catSku": "N° d'article / fabricant",
 "catUnit": "Unité",
 "unit_pcs": "pcs",
 "unit_lfm": "ml",
 "unit_m2": "m²",
 "unit_m3": "m³",
 "unit_lump": "forfait",
 "catPrice": "Prix unitaire (€)",
 "catInstall": "Pose (€)",
 "catColor": "Couleur",
 "catSym": "Symbole",
 "catKind": "Affichage",
 "kind_point": "Point (raccord / pièce)",
 "kind_pipe": "Ligne (conduite, ml)",
 "catAdd": "Nouvel article",
 "catSearch": "Rechercher … (p. ex. vanne DN 100)",
 "catAll": "Tous",
 "catExport": "Exporter (.json)",
 "catImport": "Importer",
 "catReset": "Rétablir le catalogue d'usine",
 "catResetConfirm": "Annuler vos modifications et rétablir le catalogue d'usine ?",
 "catImported": "Catalogue importé",
 "catImportErr": "Le fichier n'est pas un catalogue valide",
 "catDelConfirm": "Supprimer cet article du catalogue ?",
 "catSave": "Enregistrer",
 "catItems": "Articles",
 "matList": "Liste de matériel (réseau)",
 "matReport": "Ce rapport",
 "matProject": "Total du projet",
 "matEmpty": "Aucun article du catalogue ni conduite tracée pour le moment.",
 "colUnit": "Unité",
 "serial": "Étiquette suppl. / n° de série",
 "catPickDn": "Choisir DN",
 "pitTool": "Terrassement / fouille",
 "pitTitle": "Calculateur de fouille & de couches",
 "pitDefault": "Fouille",
 "pitShape_polygon": "Forme libre",
 "pitShape_rect": "Rectangle",
 "pitShape_circle": "Cercle",
 "alTitle": "⚠️ Fuites aiguës, dommages & défauts d'entretien du réseau",
 "alRed": "Fuite / défaut",
 "alYellow": "Entretien nécessaire",
 "alShow": "🎯 Afficher sur la carte",
 "alNav": "🧭 Naviguer avec Google Maps",
 "alNavHere": "🧭 M'y guider avec Google Maps",
 "roTitle": "Objets du réseau & fuites de l'itinéraire",
 "roPickRed": "Toutes les fuites & réparations immédiates",
 "roPickWarn": "Tous les « entretien nécessaire »",
 "roPickDue": "Tous les contrôles en retard",
 "roPickAll": "Tous / Aucun",
 "roStart": "🧭 Démarrer l'itinéraire dans Google Maps",
 "rrBtn": "Rapport de réparation (PDF)",
 "rrTitle": "Certificat de réparation",
 "rrCoords": "Coordonnées",
 "rrMap": "Emplacement de la pièce",
 "rrNoPhotos": "Aucune photo avant/après jointe.",
 "rrSignTech": "Réalisé par : {by}",
 "rrSignClient": "Client (réception)",
 "rrPlaceDate": "Lieu, date, signature",
 "rrFile": "Repair_report",
 "rrSaved": "Rapport de réparation enregistré",
 "msTitle": "Statistiques de maintenance",
 "msAll": "Tous",
 "msFittings": "Pièces seulement",
 "msProgress": "Vérifier l’avancement",
 "svPlaceFitting": "Placer la pièce sur la cible",
 "svMarkLeak": "Marquer la fuite sur la cible",
 "svPlaced": "Pièce ajoutée à la carte à cette position",
 "mtBefore": "Avant",
 "mtAfter": "Après",
 "mtFile": "fichier",
 "mtRepairs": "Réparations",
 "mtRepairDate": "Réparé le",
 "mtRepairPrev": "État précédent",
 "svClose": "✕ Fermer Street View (retour à la carte)",
 "svExternal": "Ouvrir dans Google Maps",
 "svNoImagery": "Pas d’image ? Il se peut qu’il n’y ait pas de Google Street View à cet endroit – rapprochez le viseur d’une route.",
 "camXray": "🥽 Réseau uniquement (fond de carte désactivé)",
 "mtOverview": "Vue d’ensemble de la maintenance",
 "mtRepairedLine": "Réparé le {date} par {by} (avant : {prev})",
 "mtRepairSave": "Enregistrer la réparation",
 "mtRepairNote": "Note de réparation (optionnel)",
 "mtRepairBy": "Nom (réparé par)",
 "mtRepairBtn": "Signaler comme réparé",
 "mtIntervalsHint": "Après combien de temps une vanne ou un hydrant est considéré comme « contrôle en retard ».",
 "mtMonths": "mois",
 "mtIntervals": "Intervalles de contrôle",
 "mt_due": "Contrôle en retard",
 "dueTitle": "Contrôle en retard",
 "dueHint": "Jamais contrôlé ou pas contrôlé depuis trop longtemps (vannes : {v} mois · hydrants : {h} mois)",
 "dueNever": "jamais contrôlé",
 "mwoBtn": "Liste de maintenance (Excel)",
 "mwoTitle": "Liste d’intervention de maintenance",
 "mwoSheet": "Liste de maintenance",
 "mwoPart": "Pièce",
 "mwoType": "Type",
 "mwoStatus": "Statut",
 "mwoNote": "Note / mémo vocal",
 "mwoDone": "Fait le / par",
 "mwoCreated": "Créé",
 "mwoItems": "éléments",
 "mwoNone": "Aucune pièce jaune ou rouge trouvée.",
 "mwoDoneToast": "Liste de maintenance exportée",
 "licAllInOne": "Une seule licence pour tout : après les 14 jours d’essai gratuits, la licence complète (€18/an) ou une clé de licence entreprise débloque instantanément 100 % des fonctions – y compris le compteur IA de matériaux sur photo.",
 "mod_all": "Édition complète (toutes les fonctions)",
 "camZoom": "Zoom caméra",
 "camTorchOn": "Lumière allumée",
 "camTorchOff": "Lumière éteinte",
 "camNoTorch": "Cet appareil n’a pas de lumière de caméra pilotable.",
 "mtTitle": "Maintenance",
 "mtLast": "Dernier contrôle",
 "mt_ok": "OK / Contrôlé",
 "mt_warn": "Maintenance nécessaire",
 "mt_defect": "Défectueux / Réparation immédiate",
 "mt_none": "Non contrôlé",
 "mtAddTag": "Défaut personnalisé …",
 "mtHistory": "Historique des contrôles",
 "mtTags": "Défauts",
 "mtFilter": "Filtrer l’état de maintenance",
 "svBtn": "Street View (vue rue 360°)",
 "svShort": "Street View",
 "svHint": "Ouvrir la vue rue 360° au niveau du viseur",
 "layerTitle": "Type de carte",
 "layer_hybrid": "Google Satellite / Hybride",
 "layer_road": "Plan Google",
 "layer_sat": "Vue aérienne (Esri)",
 "layer_osm": "OpenStreetMap (OSM)",
 "layer_topo": "Carte topographique",
 "ppTitle": "Prix du projet",
 "ppHint": "Ne saisissez que les prix différents pour ce site – les champs vides (gris = prix du catalogue principal) utilisent automatiquement le catalogue principal ou les prix globaux de fouille. Le catalogue principal reste inchangé.",
 "ppReset": "Réinitialiser tous les prix du projet",
 "ppResetConfirm": "Supprimer tous les prix spécifiques au projet ? Les prix du catalogue principal s’appliqueront de nouveau.",
 "ppDone": "Terminé",
 "sheetCost": "Aperçu des coûts",
 "vatTitle": "TVA",
 "vatRate": "Taux de TVA (%)",
 "vatHint": "S’applique à la liste de matériel et aux coûts de fouille dans l’app et le PDF.",
 "vatNet": "Total HT",
 "vatLine": "plus TVA {rate} %",
 "vatGross": "Total TTC",
 "colUnitPrice2": "Prix unitaire",
 "pitCostTitle": "Aperçu des coûts de fouille",
 "pitColExcav": "Terrassement m³",
 "pitColSand": "Sable",
 "pitColGravel": "Gravier",
 "pitColSurface": "Surface",
 "pitByMat": "Total par matériau",
 "pitNoPrice": "Pas encore de prix – veuillez les saisir sous Paramètres > Prix de terrassement.",
 "catShare": "Partager par QR",
 "catScan": "Scanner QR",
 "catShareTitle": "Partager le catalogue par code QR",
 "catShareItems": "articles",
 "catShareHint": "Le collègue ouvre Catalogue de matériel > « Scanner QR » puis scanne ce code (ou le saisit). Valable 30 jours.",
 "catShareErr": "Impossible – veuillez vérifier la connexion Internet.",
 "catScanTitle": "Scanner le QR du catalogue",
 "catScanHint": "Placez le code QR de votre collègue dans le cadre.",
 "catScanManual": "ou saisir le code à 6 caractères",
 "catScanLoad": "Charger",
 "catScanFound": "Catalogue trouvé : {n} articles",
 "catScanReplace": "Remplacer",
 "catScanMerge": "Fusionner",
 "catScanReplaceConfirm": "Remplacer complètement votre propre catalogue par celui reçu ?",
 "catScanMergeHint": "Fusionner : les nouveaux articles sont ajoutés, les articles identiques mis à jour – vos propres articles sont conservés.",
 "catScanNotFound": "Code introuvable ou expiré.",
 "catScanCamErr": "Caméra non disponible – veuillez saisir le code manuellement.",
 "pitHint_polygon": "Touchez les sommets l’un après l’autre (min. 3), puis « Terminer ». Ensuite, faites glisser les sommets = corriger, la poignée centrale = déplacer toute la zone.",
 "pitHint_rect": "Faites glisser le doigt d’un coin à l’autre – ou touchez deux coins / saisissez longueur × largeur.",
 "pitHint_circle": "Faites glisser le doigt du centre vers l’extérieur – ou touchez le centre + le bord / saisissez le diamètre.",
 "pitLen": "Longueur (m)",
 "pitWid": "Largeur (m)",
 "pitDia": "Diamètre (m)",
 "pitPlace": "Placer au réticule",
 "pitArea": "Surface (m²)",
 "pitDepth": "Profondeur totale de tranchée (m)",
 "pitDn": "Diamètre nominal DN",
 "pitOd": "Ø extérieur de conduite (m)",
 "pitPipeLen": "Longueur de conduite en tranchée (m)",
 "pitBed": "Lit de pose sous conduite (cm)",
 "pitCover": "Recouvrement au-dessus de la conduite (cm)",
 "pitColLayer": "Couche (de bas en haut)",
 "pitColThick": "Épais. cm",
 "pitColDens": "t/m³",
 "pitColPrice": "Prix unitaire",
 "pitColCost": "Coût",
 "pitL_sand": "Lit de sable / zone de conduite",
 "pitL_fill": "Remblai principal gravier / protection hors gel",
 "pitL_excav": "Terrassement total / évacuation",
 "pitM_asphalt": "Couche de surface en asphalte",
 "pitM_topsoil": "Terre végétale",
 "pitM_disposal": "Évacuation / mise en décharge des déblais",
 "pitM_sand": "Sable de pose",
 "pitM_gravel": "Gravier / concassé / protection hors gel",
 "pitSurface": "Surface",
 "pitSurf_none": "sans couche de surface",
 "pitAddLayer": "Couche personnalisée",
 "pitLayerName": "Désignation",
 "pitPipeDisp": "Déplacement de conduite",
 "pitTotal": "Coût total des matériaux",
 "pitSave": "Enregistrer dans le rapport",
 "pitSaved": "Fouille enregistrée dans le rapport",
 "pitDelete": "Supprimer",
 "pitConfirmDel": "Supprimer vraiment cette fouille ?",
 "pitNeed3": "Au moins 3 points nécessaires",
 "pitPrices": "Prix de terrassement et remblayage",
 "pitPriceHint": "Prix unitaires pour le calculateur de fouille – par m³, t ou m².",
 "pitSection": "Terrassement et remblayage",
 "pitSum": "Total de toutes les fouilles",
 "pitCount": "Fouilles",
 "pitNote": "Remarque",
 "pitExcav": "Terrassement",
 "pitInvalid": "Veuillez saisir des dimensions valides",
 "resetTitle": "Données sur cet appareil",
 "resetBtn": "Supprimer toutes les données",
 "resetWord": "DELETE",
 "resetInfo": "Supprime tous les projets, rapports, photos, vidéos, notes vocales, conduites/raccords, prix, logo et recherches récentes. La licence, l’ID de l’appareil et la langue sont conservés.",
 "resetConfirm": "Tapez “{w}” pour confirmer",
 "resetGo": "Supprimer définitivement",
 "resetDone": "Toutes les données ont été supprimées",
 "cancel2": "Annuler",
 "gpsFollow": "Suivre",
 "gpsFollowOff": "Suivi désactivé",
 "memoLast": "Note vocale sur le dernier objet",
 "memoBubble": "Ajouter une note vocale",
 "memoSaved": "Note vocale enregistrée",
 "memoNone": "Aucun objet placé pour l’instant",
 "btnBack": "Retour",
 "fsEnter": "Plein écran",
 "fsExit": "Quitter le plein écran",
 "fsTools": "Outils",
 "fsPipe": "Tracer une conduite",
 "fsFitting": "Placer un raccord",
 "fsLeak": "Marquer un dommage / une fuite",
 "fsPhoto": "Prendre une photo",
 "fsVideo": "Enregistrer une vidéo",
 "fsGps": "Ma position",
 "camOpacity": "Transparence de la caméra",
 "camShot": "Photo",
 "camRec": "Enregistrer",
 "camStop": "Arrêter",
 "camClose": "Fermer la caméra",
 "camErr": "Caméra indisponible – veuillez autoriser l’accès à la caméra",
 "camSaved": "Enregistré dans le rapport (position du réticule)",
 "camHint": "Déplacez la carte sous l’image de la caméra pour aligner les conduites avec la réalité",
 "pdfFittings": "RACCORDS / POINTS DE RÉSEAU",
 "editPhoto": "Annoter",
 "edTitle": "Annoter la photo",
 "edArrow": "Flèche",
 "edMeasure": "Mesure",
 "edPen": "Stylo",
 "edRect": "Cadre",
 "edCircle": "Cercle",
 "edText": "Texte",
 "edUndo": "Annuler",
 "edClear": "Tout effacer",
 "edSave": "Enregistrer",
 "edCancel": "Annuler",
 "edPromptMeasure": "Saisir la mesure (p. ex. 2.40 m) :",
 "edPromptText": "Saisir le texte :",
 "edited": "Annoté",
 "pipesTitle": "Conduites / Réseau de conduites",
 "btnDrawPipe": "Tracer une conduite",
 "drawPoints": "Points",
 "btnFinish": "Terminer",
 "btnUndo": "Annuler",
 "btnCancel": "Annuler",
 "noPipes": "Aucune conduite pour l’instant. Démarrez « Tracer une conduite » et touchez la carte.",
 "pipeName": "Nom",
 "pipeDn": "DN / Matériau",
 "pipeDefault": "Conduite ",
 "pipeLength": "Longueur",
 "pipeTotal": "Longueur totale",
 "pipeNeed2": "Au moins 2 points requis",
 "confirmDelPipe": "Supprimer cette conduite ?",
 "type_water": "Eau potable",
 "type_sewer": "Égout",
 "type_gas": "Gaz",
 "type_fire": "Eau incendie",
 "type_other": "Autre",
 "pdfPipes": "RÉSEAU DE CONDUITES / CONDUITES",
 "pdfRoute": "Tracé",
 "online": "En ligne",
 "offline": "Hors ligne",
 "btnCacheArea": "Enregistrer la zone cartographique hors ligne",
 "cacheDone": "Tuiles de carte enregistrées hors ligne : ",
 "cacheErr": "Échec de l’enregistrement hors ligne (pas de connexion ?)",
 "btnConfirmPos": "Confirmer la position et verrouiller",
 "btnUnlock": "Déverrouiller la position",
 "lockedBadge": "Photo principale verrouillée",
 "editBadge": "Mode édition – déplacer et aligner la carte, puis confirmer",
 "lockedHint": "Position et alignement verrouillés. Utilisez \"Déverrouiller la position\" pour modifier.",
 "confirmedMsg": "Position confirmée et verrouillée",
 "unlockedMsg": "Position déverrouillée – définir la nouvelle position",
 "locale": "en-US",
 "projLabel": "1. Projet (site principal / réseau d’alimentation en eau)",
 "btnNewProj": "Nouveau projet",
 "projPlaceholder": "Titre du projet (p. ex. Réseau de conduites d’eau potable Nord)",
 "repLabel": "2. Rapports / emplacements de chantier dans ce projet",
 "btnNewRep": "Nouveau rapport ici",
 "repPlaceholder": "Titre de l’emplacement (p. ex. Section de fouille 4 / réparation de vanne)",
 "mapSectionTitle": "Vue d’ensemble de la carte du projet et alignement libre de l’image",
 "mapHint": "Touchez une punaise photo de site sur la carte pour ouvrir son rapport. Utilisez \"Afficher tous les sites du projet\" pour dézoomer et voir toutes les stations.",
 "btnTakeMain": "Prendre une photo de superposition cartographique",
 "btnFitAll": "Afficher tous les sites du projet",
 "btnGps": "GPS",
 "btnToggleOv": "Superposition",
 "fit_cross4": "Croix de vannes (4 voies)",
 "fab_cross4": "X4",
 "fit_tee3": "Té de vannes (3 voies)",
 "fab_tee3": "T3",
 "fit_meter": "Compteur d'eau (WM) dans le bâtiment",
 "fab_meter": "WM",
 "fit_gg": "Limite de propriété",
 "fab_gg": "PB",
 "fit_gk": "Bord du bâtiment / traversée de mur",
 "fab_gk": "BE",
 "plcCross": "Placer sur le réticule",
 "plcDock": "Ancrer à l’extrémité de la conduite",
 "plcSurvey": "Placer via levé du bâtiment",
 "plcNoPipe": "Aucune conduite à ancrer",
 "bndGG": "Marquer le point comme limite de propriété",
 "bndGK": "Marquer le point comme bord du bâtiment / traversée de mur",
 "bndAsk": "Zone privée – comment continuer ?",
 "bndOptA": "Placer sans levé (tracé inconnu)",
 "bndOptB": "Continuer avec levé (pointillé)",
 "privPipe": "Conduite privée (mesurée)",
 "privHint": "ℹ️ Levé de conduite privée/intérieure : tracez jusqu’au compteur et saisissez la longueur réelle de conduite dans la fiche objet (y c. cave/colonne montante pour la corrélation / détection de fuite).",
 "privModeOn": "Zone privée sans levé active – placer librement les éléments",
 "privModeEnd": "Terminer",
 "privModeHint": "Placez maintenant librement les éléments (compteur, vanne d’arrêt principale, réducteur de pression …) – ils reçoivent la note « tracé privé inconnu ».",
 "privUnknown": "Tracé privé depuis le bord du bâtiment / la limite inconnu (pas de levé)",
 "privUnknownShort": "tracé intérieur inconnu",
 "privShort": "Privé",
 "privLen": "Longueur de conduite privée/intérieure (m)",
 "lenPublic": "Conduite publique (jusqu’à la limite / au bord du bâtiment)",
 "lenPrivate": "Conduite privée (propriété / bâtiment, mesurée)",
 "rotTitle": "Pivoter l’orientation",
 "redTitle": "Changement de diamètre et de matériau au branchement (principale ➔ branchement maison)",
 "redFrom": "Principale",
 "redMat": "Matériau",
 "redLabel": "Branchement / réduction",
 "svySketchTitle": "Croquis de levé",
 "svySketchHint": "Croquis manuels à l’échelle des levés de bâtiment : mur A–B (gris), élément (bleu), cotes en pointillé.",
 "maskHide": "Masquer le panneau",
 "maskShow": "Afficher le panneau",
 "uiFree": "Tout masquer / vider la carte",
 "uiFreeOff": "Afficher les onglets et panneaux",
 "type_power": "Câble électrique",
 "type_telecom": "Télécom / fibre / câble de données",
 "fit_cjoint": "Manchon de câble",
 "fab_cjoint": "CJ",
 "fit_cabinet": "Armoire de distribution",
 "fab_cabinet": "DC",
 "cat_cable": "Câbles enterrés (électricité / télécom)",
 "sub_ns": "Basse tension (BT 0.4 kV)",
 "sub_ms": "Moyenne tension (MT 10–30 kV)",
 "sub_hs": "Haute tension (HT)",
 "sub_light": "Éclairage public",
 "sub_earth": "Câble de mise à la terre",
 "sub_fiber": "Fibre optique (FTTH)",
 "sub_copper": "Câble téléphonique / cuivre",
 "sub_signal": "Câble de commande et signalisation",
 "sub_duct": "Fourreau de câble / gaine vide",
 "svyTitle": "Levé",
 "svyTitleLong": "Levé depuis le bâtiment / corriger la position",
 "svyBtn": "Levé depuis le bâtiment / corriger la position",
 "svyBtnShort": "Levé",
 "svyCornerA": "Angle 1",
 "svyCornerB": "Angle 2",
 "svyTapCorner": "Touchez le point sur le bord du bâtiment sur la carte",
 "svyM_arc": "Intersection d’arcs (distances)",
 "svyM_ortho": "Orthogonal (ligne de décalage + distance)",
 "svyHint_arc": "Définissez le point A (et éventuellement B) sur le bord du bâtiment puis saisissez les distances mesurées sur site. Avec A et B, l’intersection des deux cercles est calculée (celle la plus proche de la position actuelle) ; avec seulement A, le point est déplacé vers la position actuelle.",
 "svyHint_ortho": "Définissez A et B le long du mur. Chaînage = distance depuis A vers B, décalage = perpendiculaire au mur (gauche/droite en regardant de A vers B).",
 "svyLabelA": "Point A (p. ex. angle 1)",
 "svyLabelB": "Point B (p. ex. angle 2)",
 "svyPickA": "Définir le point A",
 "svyPickB": "Définir le point B",
 "svyAlong": "Chaînage",
 "svyOffset": "Décalage perpendiculaire",
 "svySide": "Côté (en regardant A → B)",
 "svyRight": "droite",
 "svyLeft": "gauche",
 "svyDistA": "Distance A",
 "svyDistB": "Distance B",
 "svyApply": "Calculer et appliquer la position",
 "svyNoSolution": "Aucune solution – vérifiez les distances ou les points",
 "svyApplied": "Position corrigée à partir des mesures sur bâtiment",
 "svyVertexHint": "Insérer un sommet : déverrouillez le réseau et touchez la conduite. Touchez le sommet → « 📐 Levé », faites glisser pour déplacer ou supprimer.",
 "visTitle": "Afficher / masquer les objets",
 "visShort": "Objets",
 "visAllOn": "Tout afficher",
 "visAllOff": "Tout masquer",
 "visHint": "S’applique à la carte, au plein écran et à la caméra AR. L’alarme de conduite en fouille vérifie toujours toutes les conduites, y compris celles qui sont masquées.",
 "vis_water": "Eau potable",
 "vis_gas": "Gaz",
 "vis_sewer": "Assainissement",
 "vis_power": "Câbles électriques",
 "vis_telecom": "Télécom / fibre",
 "vis_otherPipes": "Autres conduites",
 "vis_fittings": "Équipements / poteaux incendie / vannes",
 "vis_leaks": "Fuites / dommages",
 "vis_loggers": "Enregistreurs de bruit",
 "vis_pits": "Fouilles",
 "vis_dims": "Levé de bâtiment / cotes",
 "plNone": "Aucune conduite dans la zone de fouille (≤ 1 m).",
 "plAlarm": "ATTENTION : conduite / câble enterré dans la zone de fouille !",
 "plTitle": "Conduites dans cette fouille",
 "plCrossing": "croisement",
 "plIncluded": "Conserver dans le protocole de fouille et le calcul",
 "plExcluded": "Exclu (ignoré pour ce protocole)",
 "plDepth": "Profondeur / recouvrement (m sous terrain)",
 "plDist": "Distance au bâtiment / bord de fouille (m)",
 "plMat": "Matériau / type de câble",
 "plState": "État en fouille ouverte",
 "plSt_ok": "OK",
 "plSt_coat": "Revêtement endommagé",
 "plSt_band": "Grillage avertisseur présent",
 "plSt_exposed": "Exposé / non sécurisé",
 "plSync": "Mettre à jour les données de référence",
 "plSynced": "Données de référence de conduite mises à jour",
 "uiTab_vis": "Afficher / masquer les objets",
 "uiHide": "Masquer les onglets",
 "uiShow": "Afficher les onglets",
 "uiTabsBtn": "Onglets",
 "uiMenuTitle": "Personnaliser les boutons de la carte",
 "uiCompact": "Mode compact / terrain",
 "uiAll": "Afficher tous les onglets",
 "uiFade": "Rendre les onglets semi-transparents pendant le déplacement/le zoom",
 "uiTab_fit": "Tous les sites",
 "uiTab_gps": "GPS et suivi",
 "uiTab_gnss": "GNSS / RTK",
 "uiTab_legend": "Légende",
 "uiTab_overlay": "Superposition (AR / plan)",
 "uiTab_heat": "Carte thermique",
 "uiTab_layer": "Vue carte (satellite / rue)",
 "uiTab_sv": "Street View",
 "uiTab_filter": "Voyants d'état (filtre)",
 "btnFitAllShort": "Tous les sites",
 "lgTitle": "Enregistreur de bruit",
 "lgNew": "Poser un enregistreur de bruit",
 "lgName": "Nom / numéro / emplacement de l’enregistreur",
 "lgNamePh": "p. ex. Enregistreur 3 – angle de vanne de la rue de l'École",
 "lgMode_lift": "Déplacer temporairement",
 "lgMode_perm": "Permanent (installation fixe)",
 "lgCollectAfter": "Récupérer à nouveau après :",
 "lgDur_1": "1 jour (demain)",
 "lgDur_2": "2 jours",
 "lgDur_3": "3 jours",
 "lgDur_7": "7 jours",
 "lgDurCustom": "Date / heure",
 "lgSave": "Poser l’enregistreur",
 "lgPlaced": "Enregistreur posé",
 "lgMoved": "Enregistreur déplacé – le délai redémarre",
 "lgCollected": "Enregistreur récupéré",
 "lgTapMap": "Touchez la carte à l’endroit où se trouve l’enregistreur",
 "lgTapNew": "Touchez la nouvelle position de l’enregistreur sur la carte",
 "lgSt_perm": "Permanent",
 "lgSt_green": "Mesure en cours",
 "lgSt_yellow": "À récupérer bientôt",
 "lgSt_red": "Récupération due !",
 "lgPlacedAt": "Posé",
 "lgDue": "Récupérer",
 "lgMove": "Déplacer",
 "lgCollect": "Récupéré (retirer de la carte)",
 "lgDays": "jours",
 "lgOut": "en place",
 "lgDueShort": "dû",
 "lgRouteDue": "Récupérer les enregistreurs dus (rouge/jaune)",
 "lgRouteAll": "Aller à tous les enregistreurs posés",
 "lgProtocol": "Protocole des enregistreurs de bruit",
 "lgModeCol": "Type",
 "lgRemoved": "Récupéré / statut",
 "lgLying": "Heure de pose",
 "lgMovedShort": "déplacé",
 "glStart": "Lever la conduite",
 "glTitle": "Levé GNSS de conduite",
 "glPoints": "points",
 "glMeasure": "Mesurer le point",
 "glAuto": "Automatique toutes les",
 "glAutoOff": "Arrêt",
 "glFinish": "Terminer la conduite",
 "glProfile": "Profil en long",
 "glLength": "Longueur",
 "glStation": "Point kilométrique",
 "glDepth": "Profondeur",
 "glCancel": "Annuler",
 "gnssBtn": "GNSS / RTK",
 "gnssTitle": "Configurer un GNSS / RTK externe",
 "gnssSats": "Satellites",
 "gnssSatsShort": "sats",
 "gnssAcc": "Précision",
 "gnssAlt": "Hauteur d'antenne alt. m",
 "gnssGeoid": "Géoïde",
 "gnssGround": "Niveau du sol",
 "gnssNN": "alt. m",
 "gnssPipe": "Fil d'eau",
 "gnssCoords": "Coordonnées (8 décimales)",
 "gnssEst": "estimé d'après la précision",
 "gnssFix_rtk": "RTK FIX (précision centimétrique)",
 "gnssFix_float": "RTK FLOAT (décimétrique)",
 "gnssFix_dgps": "DGPS / SBAS",
 "gnssFix_gps": "GPS standard (fix 3D)",
 "gnssFix_none": "Pas de fix",
 "gnssConn": "Type de connexion",
 "gnssMode_system": "GNSS / RTK système avec position simulée (Android / iOS / appli fournisseur)",
 "gnssMode_ble": "Bluetooth LE (flux NMEA Web Bluetooth)",
 "gnssMode_serial": "USB / série / Bluetooth COM (API Web Serial)",
 "gnssMode_ws": "Wi-Fi / flux WebSocket local (p. ex. Emlid Reach IP:port)",
 "gnssUnsupported": "Non disponible dans ce navigateur",
 "gnssBaud": "Débit en bauds",
 "gnssSim": "Mode simulation / test (démo)",
 "gnssHint_system": "Utilise la position de l'appareil avec la meilleure précision. Pour le RTK : activez l'appli du fournisseur (p. ex. Emlid Flow, Leica Zeno Connect) comme position simulée.",
 "gnssHint_ble": "Allumez le récepteur, activez le Bluetooth et associez-le dans le sélecteur (NMEA Nordic UART). Chrome / Edge uniquement.",
 "gnssHint_serial": "Connectez le récepteur par câble USB ou Bluetooth COM, choisissez le débit et autorisez le port. Chrome / Edge sur PC / Android uniquement.",
 "gnssHint_ws": "Saisissez l'URL du flux du récepteur (NMEA via WebSocket) ou utilisez le mode simulation pour les démos.",
 "gnssConnect": "Connecter",
 "gnssDisconnect": "Déconnecter",
 "gnssConnected": "GNSS connecté",
 "gnssConnErr": "Échec de la connexion",
 "gnssSettings": "Antenne, canne & qualité",
 "gnssDevice": "Nom de l'appareil / modèle du récepteur",
 "gnssOther": "Autre",
 "gnssAntenna": "Hauteur d'antenne / canne (m)",
 "gnssDepth": "Fil d'eau / décalage de profondeur (m)",
 "gnssAvg": "Moyennage du point",
 "gnssAvg_1": "1 mesure (instantané)",
 "gnssAvg_5": "5 époques (5 s)",
 "gnssAvg_10": "10 époques (10 s)",
 "gnssWarn": "Alerte si la précision est inférieure à",
 "gnssPlaceFit": "Placer la pièce à la position GNSS",
 "gnssPlaceRep": "Placer le point de rapport à la position GNSS",
 "gnssNoFix": "Pas de fix GNSS – veuillez connecter le récepteur",
 "gnssPickFirst": "Choisissez d'abord la pièce (Outils > Raccord ou Fuite), puis touchez « Placer la pièce à la position GNSS »",
 "gnssAveraging": "Moyennage GNSS – époques",
 "gnssWarnAcc": "Avertissement : précision inférieure au seuil",
 "gnssPlacedFit": "Pièce placée avec données de précision GNSS",
 "gnssPlacedRep": "Point de rapport défini à la position GNSS",
 "sevTitle": "Gravité",
 "sev_small": "Faible",
 "sev_medium": "Moyenne",
 "sev_large": "Élevée",
 "heatPdfTitle": "Carte thermique des dommages",
 "heatPdfHint": "Image thermique de toutes les fuites (pondérées par gravité : faible 0.5 / moyenne 1 / élevée 2) et des pièces défectueuses (0.5) – les clusters révèlent les zones problématiques du réseau.",
 "heatLow": "faible",
 "heatHigh": "élevé",
 "heatBtn": "Carte thermique",
 "heatHint": "Carte thermique des dommages : clusters de fuites et défauts",
 "leakPhotoAsk": "Fuite placée – joindre une photo comme preuve ?",
 "leakPhotoBtn": "Prendre une photo",
 "leakPhotoSkip": "Ignorer",
 "leakPhotoSaved": "Photo de fuite enregistrée",
 "leakPhotoCap": "Preuve photo de la fuite",
 "ovTakePhoto": "Prendre une photo",
 "ovGallery": "Charger une image depuis la galerie",
 "ovShow": "Afficher l'image",
 "ovHide": "Masquer l'image",
 "ovMapBg": "Fond de carte",
 "ovXray": "Vue rayon X (caméra en direct)",
 "qfTitle": "Filtres rapides",
 "qf_last": "Dernier objet uniquement",
 "qf_leaks": "Fuites et défauts uniquement",
 "qf_maint": "Maintenance nécessaire uniquement",
 "qf_all": "Tout afficher",
 "btnMoveHere": "Définir le rapport actif ici",
 "lblRotate": "Rotation libre",
 "lblScale": "Échelle de l'image",
 "lblOpacity": "Opacité",
 "photosTitle": "Photos du rapport sélectionné",
 "btnAddDetail": "Détail / Réparation",
 "btnAddNote": "Note manuscrite",
 "btnGallery": "Galerie",
 "textTitle": "Texte du rapport terrain",
 "textPlaceholder": "Rédiger le rapport terrain (p. ex. réseau d'eau potable, détails de réparation, mesures, notes)...",
 "exportTitle": "Exporter et partager (dans la langue d'application sélectionnée)",
 "btnPdfSingle": "PDF : rapport sélectionné",
 "btnPdfAll": "PDF : projet complet",
 "btnKmzAll": "KMZ (Google Earth) : projet complet et photos",
 "btnOpenGmaps": "Ouvrir dans Google Maps",
 "btnSaveJson": "Enregistrer la sauvegarde du projet (.giss)",
 "btnLoadJson": "Charger le projet (.giss)",
 "savedMsg": "Enregistré à ",
 "saving": "Enregistrement…",
 "roleMain": "Photo principale sur la carte (rotation libre sur la carte)",
 "roleDetail": "Complément : Détail / Réparation / Conduite",
 "roleNote": "Complément : Note manuscrite / Croquis",
 "roleGeneral": "Complément : Photo générale du site",
 "badgeMain": "Photo active en surimpression sur la carte",
 "captionPlaceholder": "Légende / note photo...",
 "noPhotos": "Aucune photo pour le moment. Prenez une photo de surimpression cartographique ou des photos de détail.",
 "noMainHint": "Aucune photo principale – surimpression inactive",
 "pdfHeader": "RAPPORT DE CHANTIER / DOCUMENTATION DE PROJET",
 "pdfProject": "Projet :",
 "pdfReportPoint": "Localisation du site :",
 "pdfDate": "Date / Heure :",
 "pdfCoords": "Coordonnées cartographiques :",
 "pdfAngle": "Rotation de l'image :",
 "pdfReportText": "Rapport terrain / Constatations :",
 "pdfMapTitle": "Orientation sur carte satellite et photo du site positionnée :",
 "pdfPhotosHeader": "DOCUMENTATION PHOTO ET NOTES COMPLÉMENTAIRES",
 "pdfOverview": "Vue d'ensemble des localisations du site",
 "pdfPage": "Page",
 "noText": "Aucun texte de rapport saisi.",
 "defaultProjName": "Projet de site ",
 "defaultRepName": "Localisation du site ",
 "confirmDelProj": "Supprimer ce projet et tous ses rapports de site ?",
 "confirmDelRep": "Supprimer cette localisation de rapport ?",
 "confirmDelPhoto": "Supprimer cette photo ?",
 "lastReport": "Le dernier rapport d'un projet ne peut pas être supprimé.",
 "exporting": "Création de l'export…",
 "importOk": "Projet importé",
 "importErr": "Fichier projet non valide",
 "gpsErr": "Position GPS indisponible",
 "setMain": "Définir comme principal",
 "reports": "Rapports",
 "photos": "Photos",
 "svyStepLbl": "Étape",
 "svyRefHouse": "Façade du bâtiment",
 "svyN1": "1 point (distance)",
 "svyN2": "2 points (arc)",
 "svyStep1": "Déplacez la carte jusqu'à ce que le réticule rouge soit exactement sur le point 1 (p. ex. angle du bâtiment), puis confirmez.",
 "svyStep2": "Alignez maintenant le réticule exactement sur le point 2 (deuxième angle), puis confirmez.",
 "svyStep3a": "Saisissez la distance mesurée de P1 à l’élément (direction : de P1 vers la position actuelle de l’élément).",
 "svyStep3b": "Saisissez les distances mesurées de P1 et P2 à l’élément.",
 "svyConfirmP1": "Confirmer P1 au réticule",
 "svyConfirmP2": "Confirmer P2 au réticule",
 "svyConfirmSet": "Calculer et placer",
 "svyDist": "Distance",
 "svyBack": "Retour",
 "svyNeedDist": "Veuillez saisir des distances valides (> 0 m)",
 "svyNeedDir": "Déplacez le réticule vers l’élément (direction manquante)",
 "svySamePt": "P2 = P1 – déplacez le réticule vers le deuxième angle",
 "bndGGx": "PB au réticule",
 "bndGKx": "BE au réticule",
 "svyApprox": "Approximation : la distance cartographique P1–P2 ne correspond pas aux mesures – l’objet est placé au rapport A : B entre P1 et P2.",
 "svyBendHint": "📐 Levé de coude : visez d’abord avec le réticule l’arête du bâtiment/point fixe P1 (et P2), puis confirmez la distance jusqu’au sommet (centre) du coude. Dans le levé photo, marquez le point fixe et le sommet du coude avec le réticule.",
 "svyVertexLbl": "Sommet/coude",
 "svyKindArc": "Intersection d’arcs (2 points)",
 "svyKindRay": "Distance à 1 point",
 "svyInfoTitle": "Objet levé (vérifier la mesure disponible)",
 "svyInfoTitleV": "Point de conduite levé",
 "svyInfoKind": "Type de levé",
 "svyInfoRef": "Référence",
 "svyFrom": "Depuis",
 "svyEdit": "Modifier le levé / refaire le levé",
 "svpHowTo": "Prenez une photo depuis le point de mesure en direction de l’objet, puis marquez le point fixe et l’objet avec le réticule.",
 "svpAimFix": "Déplacez le réticule sur {p} (point fixe) et confirmez",
 "svpConfirmFix": "Confirmer {p} sur la photo",
 "svpAimTarget": "Déplacez le réticule sur l’objet {o} et confirmez",
 "svpConfirmTarget": "Confirmer l’objet et enregistrer",
 "svpBtnA": "Photo P1",
 "svpBtnB": "Photo P2",
 "svpBtnAB": "Vue d’ensemble (P1 + P2)",
 "svpTip": "Photo depuis {p} vers {o}",
 "svpSaved": "Photo de levé avec cote enregistrée",
 "svpPdfTitle": "Photos de levé",
 "svRadar": "Radar",
 "svSplit": "Écran partagé",
 "svArObjects": "objets",
 "svSyncHint": "Pivoter avec ◄ ► / cône de vue (les rotations dans l’image ne sont pas détectées). Faites glisser ou touchez la cible 🎯 sur la carte 2D.",
 "fpTitle": "Profil de fonctions (afficher/masquer)",
 "fpHint": "Un seul tarif pour tout (18 €/an). N’affichez que les fonctions dont vous avez vraiment besoin.",
 "fp_garden": "Standard / Maison & Jardin",
 "fp_gardenDesc": "Mesure de surfaces, terrains et bâtiments par satellite, AR et photo, conduites privées, export PDF",
 "fp_pro": "Pro / Génie civil & détection de fuites",
 "fp_proDesc": "Tout : réseau de conduites, alarme de conflit de fouille, levé de bâtiment, déplacement d’enregistreurs de bruit avec itinéraire, facturation DQE",
 "ft_network": "Dessiner les conduites / le réseau",
 "ft_pits": "Fouilles & alarme de conflit",
 "ft_survey": "Levé de bâtiment",
 "ft_loggers": "Enregistreurs de bruit (déplacement)",
 "ft_gnss": "GNSS / RTK-GPS",
 "ft_maint": "Maintenance & échéances",
 "ft_lv": "Facturation DQE / prix",
 "ft_inventory": "Compteur de matériel IA",
 "ft_route": "Tournée du jour",
 "playUnlock": "Débloquer maintenant via Google Play Store / démarrer l’abonnement",
 "playYear": "an",
 "playTrial7": "Essai gratuit de 14 jours",
 "playWebHint": "Achat impossible dans le navigateur – le bouton ouvre l’application dans le Google Play Store.",
 "trialBanner": "Essai gratuit actif : il reste {days} jours. Ensuite, continuez pour 18 €/an via Google Play.",
 "shBtn": "Partager",
 "shTitle": "Partager l’application / code QR",
 "shPlayTitle": "Version Google Play Store (14 jours d’essai gratuit)",
 "shPlayHint": "Un compte Google/Gmail est requis pour le test. Scannez le code QR ou appuyez sur le bouton.",
 "shOpenPlay": "Ouvrir dans Google Play Store (tester avec un compte Gmail)",
 "shQrPng": "Code QR comme image (pour les publications)",
 "shGmailTitle": "Envoyer l’adresse Gmail pour l’accès Play Store",
 "shGmailSend": "Envoyer",
 "shGmailBad": "Veuillez saisir une adresse @gmail.com valide",
 "shGmailOk": "Adresse Gmail enregistrée – vous serez ajouté au groupe de testeurs.",
 "shGmailMsg": "Veuillez ajouter au groupe de testeurs Play Store :",
 "shSocial": "Partager sur les réseaux sociaux",
 "shPostText": "GISS FieldRapport Pro – documentez conduites, fuites et chantiers par satellite, AR et photo. 14 jours gratuits sur le Google Play Store :",
 "shCopy": "Copier le lien",
 "shCopied": "Texte et lien copiés",
 "shTiktokCopied": "Texte et lien copiés – collez-les dans votre légende/bio TikTok",
 "shMore": "Plus…",
 "shAdmin": "Admin : liens Play Store et testeurs",
 "shEditLinks": "Modifier les liens Play Store",
 "shTestersCsv": "Liste des testeurs (CSV)",
 "shPlayUrlBad": "Le lien doit commencer par https://play.google.com/",
 "contactWa": "Numéro WhatsApp",
 "contactPlayUrl": "Lien Play Store (store/apps/details?id=…)",
 "contactPlayTest": "Lien de test Play (apps/testing/…)",
 "btnInstallPc": "Installer comme application de bureau sur ce PC",
 "officeBtn": "Écran Office partagé",
 "officeTitle": "Écran Office partagé : grande carte à gauche, formulaires et tableau des pièces à droite",
 "trBtn": "Téléphone ⇄ PC",
 "trTitle": "Transfert téléphone ⇄ PC (continuer sur PC)",
 "trExportTitle": "Exporter / partager le projet complet pour PC",
 "trExportHint": "Y c. photos, conduites, levés et enregistreurs sous forme de fichier .giss.json. Projet :",
 "trShare": "Partager le fichier projet (e-mail, Drive, WhatsApp …)",
 "trDownload": "Télécharger le fichier",
 "trAttachHint": "Astuce : pour e-mail / Drive / WhatsApp Web, le fichier est d’abord téléchargé – puis joint.",
 "trShareText": "Fichier projet GISS FieldRapport – ouvrir sur PC à l’adresse :",
 "trNoShare": "Menu de partage non disponible – fichier téléchargé.",
 "trDownloaded": "Fichier projet téléchargé",
 "trImportTitle": "Ouvrir sur PC un projet provenant du téléphone",
 "trDrop": "Glissez le fichier .giss.json ici ou cliquez",
 "trDropWrong": "Veuillez utiliser un fichier projet .giss.json / .giss",
 "trPcTitle": "Ouvrir sur PC",
 "trPcHint": "Ouvrez cette adresse web sur votre PC/portable dans Chrome ou Edge :",
 "trPcLicHint": "Version complète sur PC : menu licence › code de déverrouillage PC (Gmail + code).",
 "pcTitlePhone": "Code de déverrouillage PC (PC de bureau sans payer deux fois)",
 "pcTitlePc": "Déverrouiller ce PC avec la licence du téléphone",
 "pcHintPhone": "Saisissez l’adresse Gmail et créez le code. Sur le PC, saisissez Gmail + code – valable comme votre abonnement téléphone, pour 1 PC.",
 "pcHintPc": "Saisissez l’adresse Gmail et le code de déverrouillage PC depuis le menu licence de votre téléphone.",
 "pcCreate": "Créer le code PC",
 "pcUpdate": "Mettre à jour Gmail",
 "pcActivate": "Déverrouiller le PC",
 "pcCreated": "Code de déverrouillage PC prêt",
 "pcReleased": "PC libéré – le code peut être réattribué",
 "pcActivated": "Version complète déverrouillée sur ce PC",
 "pcBound": "Affecté au PC",
 "pcFree": "Pas encore affecté à un PC",
 "pcRelease": "Libérer le PC",
 "pcActiveHere": "Ce PC est déverrouillé avec une licence téléphone",
 "pcErr_invalid": "Gmail ou code incorrect",
 "pcErr_pc_taken": "Code déjà affecté à un autre PC – utilisez « Libérer le PC » sur le téléphone",
 "pcErr_pc_paid": "Possible uniquement avec une licence payante",
 "pcErr_expired": "Licence expirée",
 "pcErr_revoked": "Licence révoquée",
 "pcErr_gmail": "Veuillez saisir une adresse @gmail.com valide",
 "altLbl": "Altitude NMM",
 "altSrcLbl": "Source de l'altitude",
 "altAsl": "NMM",
 "altHint": "Altitude au-dessus du niveau de la mer : RTK/GNSS > GPS du téléphone (lissé) > modèle de terrain (en ligne)",
 "altSrc_gnss": "GNSS/RTK",
 "altSrc_gps": "GPS lissé",
 "altSrc_dem": "Modèle de terrain",
 "altSrc_manual": "manuel",
 "altTake": "Reprendre l'altitude",
 "altErr": "Aucune altitude disponible (hors ligne / pas de GPS)",
 "vis_tracks": "Tracés (Follow Me)",
 "ft_tracks": "Follow Me / enregistrement du tracé",
 "trkTitle": "Follow Me / enregistrement du tracé",
 "trkNew": "Nouvel enregistrement",
 "trkChoose": "Choisissez un profil d’activité – l’enregistrement démarre immédiatement :",
 "trkP_gas": "Inspection du réseau gaz / contrôle en véhicule",
 "trkP_hike": "Randonnée & outdoor (loisir)",
 "trkP_leak": "Recherche de fuites / équipe à pied",
 "trkP_bike": "Vélo / tournée d'inspection",
 "trkStart": "Démarrer",
 "trkS_rec": "Enregistrement",
 "trkS_pause": "En pause",
 "trkS_done": "Terminé",
 "trkPause": "Pause",
 "trkResume": "Reprendre",
 "trkStop": "Terminer",
 "trkSave": "Enregistrer dans le projet",
 "trkDiscard": "Abandonner",
 "trkDiscardQ": "Vraiment abandonner cet enregistrement ?",
 "trkName": "Nom du parcours",
 "trkSaved": "Parcours enregistré dans le projet",
 "trkTooShort": "Trop peu de points pour un parcours",
 "trkLen": "Longueur",
 "trkTime": "Durée (hors pauses)",
 "trkUpDown": "Montée / descente",
 "trkUp": "Montée",
 "trkDown": "Descente",
 "trkSpeed": "vitesse",
 "trkMinMax": "Altitude min / max",
 "trkPoints": "points",
 "trkStartAt": "Début",
 "trkEndAt": "Fin",
 "trkScreenHint": "Remarque : l'enregistrement continue tant que l'application est ouverte – l'écran reste allumé automatiquement.",
 "trkEmpty": "Aucun parcours enregistré pour l'instant.",
 "trkToggle": "Afficher/masquer sur la carte",
 "trkDelQ": "Supprimer le parcours ?",
 "trkPdfTitle": "Rapport de parcours",
 "trkProfile": "Profil altimétrique",
 "trkPdfErr": "Le PDF n'a pas pu être créé"
};
